
  const __registry__ = require('../../../../spiferack/client/index.js')
  'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var connect = require('../../../components/connect');

var _require = require('./constants'),
    PERMISSION_NO_ACCESS = _require.PERMISSION_NO_ACCESS,
    PACKAGES_AND_SCOPES_PERMISSION = _require.PACKAGES_AND_SCOPES_PERMISSION,
    SELECTED_PACKAGES_AND_SCOPES = _require.SELECTED_PACKAGES_AND_SCOPES,
    SELECTED_SCOPES = _require.SELECTED_SCOPES,
    SELECTED_PACKAGES = _require.SELECTED_PACKAGES,
    PACKAGES_AND_SCOPES = _require.PACKAGES_AND_SCOPES;

var PackagesAndScopesInput = require('./packages-and-scopes-input');
var PermissionsInput = require('./permissions-input');
var Section = require('./section');
var formStyles = require('../../../../shared/styles/forms.css');

var PackagesAndScopesSection = function (_React$PureComponent) {
  _inherits(PackagesAndScopesSection, _React$PureComponent);

  function PackagesAndScopesSection(props) {
    _classCallCheck(this, PackagesAndScopesSection);

    var _this = _possibleConstructorReturn(this, (PackagesAndScopesSection.__proto__ || Object.getPrototypeOf(PackagesAndScopesSection)).call(this, props));

    _this.state = { permission: PERMISSION_NO_ACCESS };
    _this.onPermissionSelect = _this.onPermissionSelect.bind(_this);
    return _this;
  }

  _createClass(PackagesAndScopesSection, [{
    key: 'onPermissionSelect',
    value: function onPermissionSelect(permission) {
      this.setState({ permission: permission });
      this.props.onInputChange(PACKAGES_AND_SCOPES_PERMISSION, permission);
      // Reset the selection if no access is selected
      if (permission === PERMISSION_NO_ACCESS) {
        this.props.dispatch({
          type: 'FORM_CHANGE',
          formId: this.props.formId,
          name: SELECTED_PACKAGES_AND_SCOPES,
          value: ''
        });
        this.props.dispatch({ type: 'FORM_CHANGE', formId: this.props.formId, name: SELECTED_SCOPES, value: [] });
        this.props.dispatch({ type: 'FORM_CHANGE', formId: this.props.formId, name: SELECTED_PACKAGES, value: [] });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          formId = _props.formId,
          formData = _props.formData,
          allScopes = _props.allScopes,
          allPackages = _props.allPackages,
          onInputChange = _props.onInputChange;


      var sectionId = formId + '_packages_section';
      var errorMessageId = sectionId + '_error_message';
      var errorMessage = formData[formId][PACKAGES_AND_SCOPES_PERMISSION].errorMessage;

      return React.createElement(
        Section,
        { title: 'Packages and scopes', id: sectionId },
        React.createElement(PermissionsInput, {
          formId: formId,
          name: PACKAGES_AND_SCOPES_PERMISSION,
          onSelect: this.onPermissionSelect,
          outerLabelId: sectionId,
          isInvalid: !!errorMessage,
          ariaDescribedby: errorMessageId
        }),
        this.state.permission !== PERMISSION_NO_ACCESS && React.createElement(PackagesAndScopesInput, {
          formId: formId,
          formData: formData,
          name: PACKAGES_AND_SCOPES,
          allScopes: allScopes,
          allPackages: allPackages,
          onInputChange: onInputChange
        }),
        React.createElement(
          'p',
          { id: errorMessageId, className: formStyles.errorMessage },
          errorMessage
        )
      );
    }
  }]);

  return PackagesAndScopesSection;
}(React.PureComponent);

module.exports = connect()(PackagesAndScopesSection);
  let __hot__
  
  __registry__.register('tokens/gat/packages-and-scopes-section', module.exports, __hot__)
  